module.exports = __webpack_public_path__ + "static/media/alerts.cece70e2.svg";